// extracted by mini-css-extract-plugin
export var alt = "ParagraphFooterCta-module--alt--5b9ce";
export var container = "ParagraphFooterCta-module--container--f9a25";
export var desktopOnly = "ParagraphFooterCta-module--desktopOnly--cea07";
export var main = "ParagraphFooterCta-module--main--ea24a";
export var mobileOnly = "ParagraphFooterCta-module--mobileOnly--ae037";
export var textLeft = "ParagraphFooterCta-module--textLeft--d0138";
export var visuallyHidden = "ParagraphFooterCta-module--visuallyHidden--6ea53";